import React, { useState } from 'react';
import styles from './HeaderListItemListExpandable.module.scss';
import { ArrowDropDown } from './ArrowDropDown';
import HeaderExpand from './HeaderExpand';

interface IHeaderListItemListExpandable {
  active: boolean;
  children: React.ReactNode | React.ReactNode[];
  index: number;
  label: string;
  mobile: boolean; // just checks for mobile navigation being open to infer
  name: string;
  open: number | null;
  setOpen: React.Dispatch<React.SetStateAction<number | null>>;
}

export const HeaderListItemListExpandable = ({
  active,
  children,
  index,
  label,
  mobile,
  name,
  open,
  setOpen,
}: IHeaderListItemListExpandable) => {
  const [state, setState] = useState(false);

  const handleAction = () => {
    setState(!state);
    setOpen(index === open ? null : index);
  };

  const expanded = mobile ? state : index === open;

  return (
    <li
      className={`
          ${styles['menu-item-expandable']}
          ${expanded ? styles.expanded : ''}`}
      role="menuitem"
    >
      <button
        aria-expanded={expanded}
        aria-controls={`section-${name}`}
        aria-label={name}
        id={`id-collapse-${name}`}
        className={`
            ${styles.button}
            ${active ? styles.active : ''}
          `}
        onClick={handleAction}
        onMouseEnter={() => {
          if (mobile) return;
          setOpen(index);
        }}
        type="button"
      >
        {label}
        <span className={styles.arrow}>
          <ArrowDropDown />
        </span>
      </button>
      <div className={styles.collapse} aria-labelledby={`id-collapse-${name}`} id={`section-${name}`} role="region">
        <div className={styles.container}>
          <HeaderExpand duration={mobile ? 300 : 0} expand={expanded}>
            <div className={styles.menu}>{children}</div>
          </HeaderExpand>
        </div>
      </div>
    </li>
  );
};
